import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Inject
} from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { Itab } from '@ispm/shared/interfaces/Itab';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import * as _ from 'lodash';
import { GroupingService } from '@ispm/shared/services/grouping.service';
import { Subject } from 'rxjs/Subject';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { FLAG_TYPES } from '../../constants/FlagTypes';
import {
  TabData,
  TabConfiguration,
  DynamicFormPayload,
  Button,
  ConfigData
} from '@ispm/dynamic-form/interfaces/TabConfiguration';
import { TabUtility } from '@ispm/dynamic-form/classes/tab-utility.class';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';


@Component({
  selector: 'gen-dynamic-tab',
  templateUrl: './dynamic-tab.component.html',
  styleUrls: ['./dynamic-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent()
export class DynamicTabComponent implements OnInit, IWidgetItem {


  constructor(protected groupingService: GroupingService,
              protected tabUtil: TabUtility,
              private _changeDetector: ChangeDetectorRef,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE) {
  }

  set widgetConfig(_itemConfig: IdynamicFormItem) {
    const widgetPayload = _itemConfig.widgetPayload;
    this.popUpMode = widgetPayload.popUpMode;
    this.createTabConfig(widgetPayload.tabConfig);
    this.groupIds = widgetPayload.groupIds;
  }



  set widgetData(widgetData: any) {
    this.data = widgetData;
    if (!_.isEmpty(this.data)) {
      this.data = this.tabUtil.fillValueChangeField(this.data);
      const integratedRecords = this.tabUtil.filterActiveRecords(this.data, this.deactivatedRecords);
      this.data = integratedRecords.activeRecords;
      this.deactivatedRecords = integratedRecords.deactivatedRecords;
      this.count = 1;
      this.mapWidgetData();
      this.data.push(...this.deactivatedRecords);
    }
    /**Initially if no data was present a default tab should be shown */
    if (this.tabContainer.length == 0) {
      this.initializeDefaultTab(null);
    }
    if (this.tabUtil.singleCorrelationExistWithoutDefaultTab(this.tabCorrelator, this.tabConfig[0])) {
      this.initializeDefaultTab(this.tabCorrelator.keys().next().value);
    }

    /**
     * This is required as during a update data the view mode need reload with the data ,
     * the tab loaded needs to gets the refreshed data.Therefore the based on the data mapped to
     * TabData we get based on current Tab Title.
     * @type {TabData}
     */
    const currentTab = this.tabContainer.filter(tab => tab.tabName == this.currentTabTitle)[0];
    if (currentTab) {
      this.mapConfigData(currentTab.config, currentTab.data);
    }


    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  currentTabTitle: string;
  tabClosable: boolean = false;
  tabs: Itab[] = [];
  groupIds: string[] = [];
  primaryCancer: any;
  groupedData: any;
  isTabInitialised: boolean = false;
  buttons: Array<Button> = [];
  tabConfig: Array<TabConfiguration> = [];
  tabContainer: Array<TabData> = [];
  deactivatedRecords: Array<any> = [];
  configData: Array<ConfigData> = [];
  popUpMode: boolean = false;
  /**
   * This maintains the tabs associated to each correlation Id .
   * @type {Map<string, Array<any>>}
   */
  tabCorrelator: Map<string, Array<any>> = new Map<string, Array<any>>();
  count: number = 1;
  buttonStyle: string[] = ['gen-button-element'];
  stylemodifier: string[] = ['background-for-selection', 'indicator', 'text', '-Normal-on', 'contentprimarybackground', 'Rectangle'];
  private destroyer: Subject<any> = new Subject();
  @Input()
  public data;

  public widgetUpdateValueCallback: (value) => void;

  ngOnInit() {

  }





  /**
   * Here we pass the TabDataStructure and iterate it to get each individual tab data.
   * Each individual tabdata is a array and holds data for each section in the tab.
   * So individual section data is accumulated in the widget data to retain the original data format .
   * @param tabData
   */
  widgetDataUpdate(tabData: any) {
    const widgetData = [];
    tabData.forEach(
      eachTab => {
        eachTab.data.forEach(
          data => widgetData.push(data));
      });
    // append deactivated records
    this.deactivatedRecords.forEach(record => {
      if (!_.includes(widgetData, record)) {
        widgetData.push(record);
      }
    });
    this.data = widgetData;
  }


  /**
   * This method derives data based upon the subResourceType
   * @param data
   * @param tabItem
   * @param correlationId
   * @returns {Array<any>}
   * Currently taking first element in subResourcType Data, Need to enhance.
   * Based on the tabItem i.e : the config for tabs the data Associators are used to map data based on the sub Resource Type.
   */
  deriveDataBasedOnConfig(data, tabItem, correlationId): Array<any> {

    const subResourceType: number = 2;
    const tabContentData: Array<any> = [];
    tabItem.dataAssociator.forEach(associator => {
      /**
       *  Here when new tab is added data is empty so create objects in data array
       *  This is filled incase with respect to each config if data is not present.
       *  This happens when one of the config has data , but other config didn't have data
       *  saved .
       */
      if ((data && !data[associator.subResourceType]) || (data === null || data === undefined)) {
        tabContentData.push(this.tabUtil.fillInitialData(correlationId, tabItem, associator, this.groupIds));
      }
      else {
        let formData = { };
        formData = Object.assign(formData, _.head(data[associator.subResourceType]),
          { formId: associator.formId});
        // comparing the subResourceType with the disease type resource
        if (_.get(formData, `${this.groupIds[subResourceType]}.code`) == FLAG_TYPES.DISEASE_TYPE) {
          this.primaryCancer = formData[FLAG_TYPES.CANCER];
        }
        tabContentData.push(formData);
      }

    });
    return tabContentData;
  }


  createTabs() {
    this.tabs = [];
    this.tabContainer.forEach(itemData => {
      this.tabs.push({ name: itemData.tabName});
    });
  }

  /**
   * Here configuration are mapped and data is mapped of a init tab and the init tab is set as current tab .
   * This sets the initialization as true .
   */
  initTabs() {
    if (this.tabContainer.length > 0) {
      const firstTab = this.tabContainer[0];
      this.mapConfigData(firstTab.config, firstTab.data);
      this.currentTabTitle = firstTab.tabName;
      this.isTabInitialised = true;
    }
  }

  /**
   * Data is initially sorted based creation time , then grouping is performed based upon the grouping Ids sequence by the grouping service
   * The tabData is emptied and tabMapType is also emptied .
   * tabData manages the  complete details as the name of the tab and the config associated to it with the data .
   * tabMapType manages the tabName associated with it's grouping id .
   */
  mapWidgetData() {
    this.groupedData = this.groupingService.getGrouppedData(_.orderBy(this.data, 'creationDate'), this.groupIds);

    /**
     * This call to map returns value and the key as id against the first Grouping Attribute.
     */
    this.tabContainer = [];
    this.tabCorrelator.clear();
    _.map(this.groupedData, function (tabTypes, correlationId) {
      Object.keys(tabTypes).forEach(tabType => {
        const tabconfig = this.tabConfig.find(config => {
          return config.type == tabType;
        });
        if (tabconfig) {
          const defaultTitle = tabconfig.defaultTitle;
          if (!this.tabCorrelator.has(correlationId)) {
            this.tabCorrelator.set(correlationId, new Array<{ title: string, type: string }>());
          }
          const titleIndex = _.findIndex(tabconfig.defaultTitle, '$');
          let interpolatedString = defaultTitle;
          if (titleIndex > -1) {
            interpolatedString = this.tabUtil.interpolateTitle(defaultTitle, this.data);
          }
          this.tabContainer.push({
            tabName: interpolatedString + this.count,
            config: tabconfig.config,
            data: this.deriveDataBasedOnConfig(tabTypes[tabType], tabconfig, correlationId),
            correlationId: correlationId
          });
          this.tabCorrelator.get(correlationId).push({ title: interpolatedString + this.count, type: tabconfig.type});
          this.buttons = this.tabUtil.deriveButtonsRequired(this.tabCorrelator, tabconfig, this.buttons, false);
        }
      });
      this.count = this.count + 1;
    }.bind(this));
    this.createTabs();


    if (!this.isTabInitialised) {
      this.initTabs();
    }



  }

  /**
   * This create the tab config based on the payload,
   * @param payload
   */
  createTabConfig(payload) {
    if (payload) {
      payload.forEach((item) => {
        this.tabConfig.push({
          type: item.category,
          defaultTitle: item.defaultTitle,
          config: item.forms,
          dataAssociator: item.formDataAssociator,
          tabLimit: item.limit
        });
        if (item.hasOwnProperty(FLAG_TYPES.ACTION_TITLE)) {
          this.buttons.push({ buttonTitle: item.actionTitle, tabType: item.category});
        }
        if (item.hasOwnProperty(FLAG_TYPES.TAB_CLOSABLE)) {
          this.tabClosable = item.closeable;
        }
      });
    }
  }

  /**
   * Initialize the default tab with the first tab item in the configuration
   */
  initializeDefaultTab(correlationId) {
    const tabCount = 1;
    const defaultTitle = this.tabConfig[0].defaultTitle;

    this.tabs.unshift({ name: `${defaultTitle}${tabCount}`});
    const corrId = correlationId ? correlationId : StringUtils.generateGuid();
    this.tabContainer.push({
      tabName: `${defaultTitle}${tabCount}`,
      config: this.tabConfig[0].config,
      data: this.deriveDataBasedOnConfig(null, this.tabConfig[0], corrId),
      correlationId: corrId
    });
    this.mapConfigData(_.head(this.tabContainer).config, _.head(this.tabContainer).data);
    if (this.tabCorrelator.get(corrId)) {
      this.tabCorrelator.get(corrId).push({
        title: `${defaultTitle}${tabCount}`,
        type: this.tabConfig[0].type
      });
    } else {
      this.tabCorrelator.set(corrId, [{
        title: `${defaultTitle}${tabCount}`,
        type: this.tabConfig[0].type
      }]);
      this.currentTabTitle = `${defaultTitle}${this.count}`;
      this.isTabInitialised = true;
    }

  }

  /**
   * Based on the emitted buttonType find out the config for that tab. Initialize the count parameter by determining the number of such tabs.
   * Once the count is determined,if the emit type was master type which means the tabs of a particular group has the first tab as master.
   *  Primary1--Secondary1--Tertiary1 => Implies that Primary1 is master and associated tabs are grouped by a correlation Id.
   *  Primary2--Secondary2  => Implies that Primary2 is master and associated tabs are grouped by a correlation Id.
   */
  emitAddTab(buttonType) {
    // setting count to 1 as we need to find upto how many tabs on one type are there
    this.count = 0;
    let corrId: string = null;
    const masterTabType: string = this.tabConfig[0].type; // consider the first tab type in configuration as owner type
    const masterTabTitle: string = this.tabConfig[0].defaultTitle;
    const options: Array<IoptionElemet> = [];

    this.tabConfig.filter(config => buttonType == config.type).map(tabConfig => {
      let interpolatedString;
      const defaultTitle = tabConfig.defaultTitle; // default Title of requested tabType
      if (defaultTitle.indexOf('$') > -1) {
        interpolatedString = this.tabUtil.interpolateTitle(defaultTitle, this.data);
        this.tabs.forEach(tab => {
          if (tab.name.indexOf(interpolatedString)) {
            this.count++;
          }
        });
      }
      else {
        // used indexOf to support IE .
        this.tabs.forEach(tab => {
          if (tab.name.indexOf(defaultTitle) > -1) {
            this.count++;
          }
        });
      }
      /**
       * This removes the button based upon the tab limit.
       * There would be button to add a tab , while the button is clicked during the request if number of tab types are already met to
       * the tab limit then the button would be discarded.
       *
       */
      this.buttons = this.tabUtil.deriveButtonsRequired(this.tabCorrelator, tabConfig, this.buttons, true);
      /**
       * For master type tab, we derive the corrId and update tabMapType with the corrId, call the tabStructure
       * Updation to add the tab.Incase of slave tab, we find if any master types not associated to current slave type
       * If this is not the case , no master types available to associate then
       * raise error to create another master tab
       */
      if (masterTabType == tabConfig.type) {
        corrId = StringUtils.generateGuid();
        this.tabCorrelator.set(corrId, new Array<{ title: string, type: string }>());
        this.modifyTabData(tabConfig, corrId);
      }
      else {
        /**
         * Add into the options if we find any master type tab not associated to slave tabs .So we find out from the tabMapType
         * for each correlation Id , the slave tab not present
         */
        this.tabCorrelator.forEach((value, key) => {
          if (value.filter(data => data.type == tabConfig.type).length == 0) {
            value.forEach(tabName => {
              if (masterTabType == tabName.type) {
                options.push({ code: key, display: tabName.title});
              }
            });
          }

        });
        /**
         * Use the correlation Id from the options available to associate the slave tab .
         */
        if (options.length > 0) {
          corrId = _.head(options).code;
          this.modifyTabData(tabConfig, corrId);
        } else {
          let interpolatedTitle;
          if (_.findIndex(tabConfig.defaultTitle, '$') > -1) {
            interpolatedTitle = this.tabUtil.interpolateTitle(defaultTitle, this.data);
            this.notificationMessageService.error(`${this.notificationMessage.PLEASE_ADD_A} ${this.tabUtil.interpolateTitle(masterTabTitle, this.data)} for the ${interpolatedTitle}`);
          }
          else {
            this.notificationMessageService.error(`${this.notificationMessage.PLEASE_ADD_A} ${masterTabTitle} for the ${defaultTitle}`);
          }

        }
      }
    });

  }


  /**
   * This method updates the current tabData structure with new tab,it's config and data .
   * Sets the next current tab and it's config and data are mapped to ConfigData
   * @param tabConfigItem
   * @param corrId
   */
  modifyTabData(tabConfigItem, corrId) {
    const tabTitle = _.get(tabConfigItem, 'defaultTitle');
    // This is done to ensure then the new tab has next number
    this.count = this.count + 1;
    this.currentTabTitle = tabTitle + this.count;
    let interpolatedTitle;
    if (_.findIndex(tabTitle, '$') > -1) {
      interpolatedTitle = this.tabUtil.interpolateTitle(tabTitle, this.data);
      this.currentTabTitle = interpolatedTitle + this.count;
    }

    /**
     * Associate with the provided correlationId , the new tab type provided .
     */

    this.tabCorrelator.get(corrId).push({ title: this.currentTabTitle, type: tabConfigItem.type});

    /**
     * Clean the tabs array and fill the tabNames in a sequence maintained in the TabMaps which contains
     * the correlation id with the tabs
     */
    this.tabs = [];
    this.tabCorrelator.forEach((tabTypes) => {
      tabTypes.forEach(tabName => {
        this.tabs.push({ name: tabName.title});
      });
    });

    /**
     * Update the tabContainer with the requested tab to be added.
     */

    this.tabContainer.push({
        tabName: this.currentTabTitle,
        config: tabConfigItem.config,
        data: this.deriveDataBasedOnConfig(null, tabConfigItem, corrId),
        correlationId: corrId
      });



    /** Find the tabData relevant to the currentTabTitle,
     as configData needs to be updated with latest derived tabData **/
    this.tabContainer.find((tabData) => {
      if (tabData.tabName == this.currentTabTitle) {
        this.mapConfigData(tabData.config, tabData.data);
        return true;
      }
    });
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  /**
   * Based on the title emitted onChange map the relevant config and data .
   * @param tabTitle
   */
  onTabChange(tabTitle) {
    const tabData = this.tabContainer.filter(tabData => tabData.tabName == tabTitle);
    if (tabData != null && tabData != undefined && tabData.length > 0) {
      this.currentTabTitle = tabTitle;
      this.mapConfigData(tabData[0].config, tabData[0].data);
    }
  }

  /**
   * This closes the tab and deactivates the record in the tab ,also updates the tabContainer
   * @param tabTitle
   */
  onTabClose(tabTitle) {
    const tabData = this.tabContainer.filter(tabData => tabData.tabName == tabTitle);
    if (tabData && tabData.length > 0) {
      const tabMapTypeIndex = _.findIndex(this.tabCorrelator.get(_.head(tabData).correlationId), tab => tab.title == tabTitle);
      this.tabCorrelator.get(_.head(tabData).correlationId).splice(tabMapTypeIndex, 1);
      const index = _.findIndex(this.tabContainer, tabDataItem => tabDataItem === _.head(tabData));
      this.deactivatedRecords = this.tabUtil.deActivateRecords(this.tabContainer[index].data);
      this.tabContainer[index].data = this.deactivatedRecords;
      this.widgetDataUpdate(this.tabContainer);
      this.tabContainer.splice(index, 1);
      const tabIndex = _.findIndex(this.tabs, tab => tab.name === tabTitle);
      this.tabs.splice(tabIndex, 1);
    }
    this.initTabs();
    this.emitUpdate();
  }


  /**
   * This method is triggered on any change from the dynamic form,providing the index of the particular form
   * The same update change is copied to the tabData by using the current tab Title ,
   * which will get the current tab which triggered the update .
   * @param data
   * @param index
   */
  updateChanged(data, index) {
    // updating data in current config sent to dynamic form
    this.configData[index].data = data.form;
    if (this.configData[index].data[this.groupIds[2]].code === FLAG_TYPES.DISEASE_TYPE) {
      if (this.primaryCancer && this.configData[index].data[FLAG_TYPES.CANCER].code !== this.primaryCancer.code) {
        this.configData[index].data = Object.assign({ }, this.configData[index].data, {
          refreshNeed: {
            code: 3,
            title: 'Reload',
            display: 'Would you like to update the layout to match the selected cancer type?'
          }
        });
      }
    }
    // updating into the  tab data structure
    this.tabContainer.find(tabData => this.currentTabTitle == tabData.tabName).data[index] = this.configData[index].data;
    /** Indicator that the data in updated for the form */
    this.tabContainer.find(tabData => this.currentTabTitle == tabData.tabName).data[index][FLAG_TYPES.DATA_TOGGLE] = true;
    if (this.tabContainer.length > 0) {
      /** Update the data of the widget with the latest data of all the tabs in tabContainer*/
      this.widgetDataUpdate(this.tabContainer);
    }

    this.emitUpdate();
  }

  /**
   * This calls the call back function provided by the widget to update the data into the formInstance of the Widget Component.
   * Therefore if the corresponding dynamic which loads the widget would have subscribed to the changes in the widget.
   */
  emitUpdate() {
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this.data]);
    }
  }

  /**
   * This method is used to segregate the data and associated configs .
   * For example if a tabData has 3 config forms and set of 3 data . These config should be mapped to the data .
   * There there would be 3 objects of configData. This configData is passed to the view for dynamic form.
   * @param config
   * @param data
   */
  mapConfigData(config, data) {
    const formConfig: any[] = config;
    const formData: any[] = data;
    this.configData = [];

    formConfig.forEach((config, index) => {
      this.configData.push({
        config: config as DynamicFormPayload,
        data: formData[index] ? formData[index] : { }
      });
    });
  }

  ngOnDestroy(): void {
    this.destroyer.next();
    this.destroyer.complete();
  }

}








